const Vue = require("vue");

// flight booking components
import InternalFlight from "./Components/InternalFlight.vue";
import ExternalFlight from "./Components/ExternalFlight.vue";

// create vue element for flight booking
if (document.getElementById("js-flight-booking")) {
  let searchType = document
    .getElementById("js-flight-booking")
    .getAttribute("searchType");

  var vmFlight = new Vue({
    el: "#js-flight-booking",

    components: {
      InternalFlight,
      ExternalFlight,
      
    },

    data() {
      return {
        searchType: Number(searchType),

        isLoaded: false,
      };
    },

    methods: {
      // change flight search type
      changeSearchType(type) {
        this.searchType = type;
      },
    },

    created() {
      this.isLoaded = true;
    },
  });
}

//events for buttons that are out side of vue flight components
const internalFlightEl = document.getElementById("js-btn-flight-internal");
const externalFlightEl = document.getElementById("js-btn-flight-external");

if (internalFlightEl && externalFlightEl) {

  internalFlightEl.onclick = function() {
    vmFlight.changeSearchType(1);
  };

  externalFlightEl.onclick = function() {
    vmFlight.changeSearchType(2);
  };

}
